import useTranslator from "../../hooks/useTranslator";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import Twotone from "../../assets/img/Twotone.svg";
import {
  checkSalary,
  convertCurrencyFormat,
  haveValue,
  formatToStandardDate,
  getUpdatedExchangeIncome,
} from "../../helper/common";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import AuthContext from "../../context/auth/AuthContext";
import LandLordContext from "../../context/landlord/LandLordContext";

const DetailsIncomeInfo = (props) => {
  const {
    user = {},
    forensicAnalysis = null,
    handleInfoModal,
    isFromReport,
  } = props;
  const { _t } = useTranslator();
  const { user: originalUser } = useContext(AuthContext);
  const { deaWorkspace } = useContext(LandLordContext);

  const llShowOnly = localStorage.getItem("usertype") == "landlord";

  const [recordedSalary, setRecordedSalary] = useState({
    salary: 0,
    matched: 0,
  });

  const declaredIncome = getUpdatedExchangeIncome(
    user?.current_annual_income,
    user?.currency,
    originalUser,
  );

  useEffect(() => {
    if (haveValue(user)) {
      const temp_sal = checkSalary(user);
      setRecordedSalary(temp_sal);
    }
  }, [user]);

  const taxReturns =
    (forensicAnalysis?.["Tax Returns"] ?? forensicAnalysis?.["Tax returns"])
      ?.dataInJSON?.taxReturns ?? [];

  let latestTaxReturn = null;

  // ---------- SINGLE PASS ----------
  let latestAnnual = null;
  let latestAny = null;

  for (const tr of taxReturns) {
    const year = Number(tr?.taxReturnYear);
    if (!year) continue;

    // Track latest overall (old logic)
    if (!latestAny || year > Number(latestAny.taxReturnYear)) {
      latestAny = tr;
    }

    // Track latest annual (new logic)
    if (tr?.reportType === "annual") {
      if (!latestAnnual || year > Number(latestAnnual.taxReturnYear)) {
        latestAnnual = tr;
      }
    }
  }

  // If we have any tax with anual report -> Any report with new format in sorted -> Handling for old users
  latestTaxReturn =
    latestAnnual ||
    latestAny ||
    (forensicAnalysis?.["Tax Returns"] ?? forensicAnalysis?.["Tax returns"])
      ?.dataInJSON;

  return (
    <>
      <div
        className={`main_doc_div mt-3 ${
          isFromReport ? "main_doc_div_report main_doc_div_report_full" : ""
        }`}
      >
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={Twotone} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("incomeInformation")}</p>
        </div>
        <div className="row">
          <div className="col-md-4 col-6" style={{ cursor: "pointer" }}>
            <div className="Indo_form BorderB2 ">
              <p className="formlabel d-block">{_t("declaredIncome")}</p>
              <p className="placeholderTest">
                €{convertCurrencyFormat(declaredIncome ?? 0)}
              </p>
              <p className="placeholderTest converted_text">
                {user?.currency !== "EUR" && `(${_t("converted")})`}
              </p>
            </div>
          </div>
          <div className="col-md-4 col-6">
            <div className="Indo_form BorderB2 ">
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("netIncomeFromBank")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {haveValue(
                    user?.bank_details?.userDataByProvider?.[0]?.providerName,
                  ) &&
                    user?.bank_details?.userDataByProvider?.[0]
                      ?.providerName !== "Uploaded from CSV" &&
                    haveValue(recordedSalary?.salary) &&
                    recordedSalary?.salary > 0 && (
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="validationIcon"
                      />
                    )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(recordedSalary?.salary) ? (
                  <div>
                    €
                    {!Number.isNaN(recordedSalary?.salary)
                      ? convertCurrencyFormat(recordedSalary?.salary)
                      : 0}{" "}
                    {haveValue(recordedSalary?.salary) &&
                      recordedSalary?.salary > 0 &&
                      `(${moment(
                        haveValue(user?.bankVerificationDate)
                          ? user?.bankVerificationDate
                          : user?.created_at,
                      ).format("MMM YYYY")})`}
                  </div>
                ) : (
                  <div>€0</div>
                )}
              </p>
            </div>
          </div>
          {haveValue(latestTaxReturn?.grossIncome) && (
            <div className="col-md-4 col-6">
              <div
                className={`Indo_form BorderB2 ${
                  llShowOnly ? "cursor-pointer custom-tooltip" : ""
                }`}
                data-tooltip={_t("clickHereToSeeDetails")}
                onClick={() =>
                  llShowOnly &&
                  handleInfoModal(
                    forensicAnalysis?.["Tax Returns"] ??
                      forensicAnalysis?.["Tax returns"],
                  )
                }
              >
                <div className="d-flex align-items-center gap-1 ">
                  <p className="formlabel d-block ">
                    {_t("incomeFromTaxReport")}
                  </p>

                  {(
                    forensicAnalysis?.["Tax returns"] ??
                    forensicAnalysis?.["Tax Returns"]
                  )?.verifiedSource && (
                    <img
                      src={CheckIcon0}
                      alt="Verified"
                      className="validationIcon"
                    />
                  )}
                </div>

                <p className="placeholderTest">
                  €
                  {convertCurrencyFormat(
                    getUpdatedExchangeIncome(
                      originalUser?.current_workspace?.dea_rules_activated &&
                        deaWorkspace &&
                        (forensicAnalysis?.["Employment Type"]?.dataInJSON
                          ?.employmentType === "Employee" ||
                          forensicAnalysis?.["Employment Type"]?.dataInJSON
                            ?.employmentType ===
                            "Self-employed (Company Owner)")
                        ? latestTaxReturn?.netIncomeAfterDeductions
                        : latestTaxReturn?.grossIncome,
                      latestTaxReturn.currencyCode,
                      originalUser,
                    ),
                  )}{" "}
                  {/* Updated itr income to gross income as per https://www.notion.so/skortorent/Wrong-income-tax-field-34c52b5c0a8a80bfb32fe1e750eda160 */}
                  ({latestTaxReturn.taxReturnYear})
                </p>

                {latestTaxReturn.currencyCode !== "EUR" && (
                  <p className="placeholderTest converted_text">
                    ({_t("converted")})
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
        {haveValue(forensicAnalysis?.Income?.dataInJSON?.payslips) &&
        forensicAnalysis?.Income?.dataInJSON?.payslips?.length > 0 ? (
          <div className="pb-0 BorderB2">
            <p style={{ lineHeight: "normal" }} className="formlabel d-block">
              {_t("payslips")}
            </p>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          {haveValue(forensicAnalysis?.Income?.dataInJSON?.payslips) ? (
            forensicAnalysis?.Income?.dataInJSON?.payslips
              ?.filter((p) => p?.date && typeof p?.netIncome === "number") // safety
              ?.sort((a, b) => new Date(b.date) - new Date(a.date)) // 🔥 sort latest first
              ?.slice(0, 3) // then take latest 3
              ?.map((data, index) => (
                <div
                  key={`${data?.date}-${index}`}
                  className={`col-md-4 col-6 ${
                    haveValue(data) && llShowOnly
                      ? "cursor-pointer custom-tooltip"
                      : ""
                  }`}
                  data-tooltip={_t("clickHereToSeeDetails")}
                  onClick={() => {
                    if (haveValue(data) && llShowOnly) {
                      handleInfoModal(data);
                    }
                  }}
                >
                  <div className="Indo_form BorderB2 payslip_wrapper">
                    <div className="d-flex align-items-center gap-1">
                      <p className="placeholderTest my-0">
                        €
                        {convertCurrencyFormat(
                          getUpdatedExchangeIncome(
                            data?.netIncome,
                            data?.currencyCode,
                            originalUser,
                          ) ?? 0,
                        )}{" "}
                        ({formatToStandardDate(data?.date)})
                      </p>

                      {((forensicAnalysis?.Income?.verifiedSource === true &&
                        data?.verified) ||
                        data?.payslipSourceVerified ||
                        (data?.verified &&
                          data?.socialSecuritySourceVerified)) && (
                        <div className="d-flex align-items-center gap-1">
                          <img
                            src={CheckIcon0}
                            alt="Vector Icon"
                            className="validationIcon"
                          />
                        </div>
                      )}
                    </div>

                    <p className="placeholderTest converted_text">
                      {data?.currencyCode !== "EUR" && `(${_t("converted")})`}
                    </p>
                  </div>
                </div>
              ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default DetailsIncomeInfo;
